import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = { class: "card card-body mb-0" }
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_8 = { class: "col p-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_12 = { class: "col p-0" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 0,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_19 = { class: "col p-0" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  key: 1,
  class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2"
}
const _hoisted_22 = { class: "col p-0" }
const _hoisted_23 = { class: "form-check small mb-0" }
const _hoisted_24 = {
  class: "form-check-label",
  for: "isDeleted"
}
const _hoisted_25 = { class: "form-group mb-2 col" }
const _hoisted_26 = { class: "col-auto p-0 text-end" }
const _hoisted_27 = { class: "col-sm-12" }
const _hoisted_28 = { class: "card card-body" }
const _hoisted_29 = { class: "overflow-auto" }
const _hoisted_30 = { class: "table table-striped border-light align-middle text-left text-nowrap position-relative" }
const _hoisted_31 = { class: "text-capitalize-first w-25" }
const _hoisted_32 = { class: "text-capitalize-first" }
const _hoisted_33 = {
  key: 0,
  class: "text-capitalize-first"
}
const _hoisted_34 = ["title"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "d-flex float-end" }
const _hoisted_37 = { class: "d-flex flex-row" }
const _hoisted_38 = { class: "d-flex align-items-center me-2" }
const _hoisted_39 = {
  key: 0,
  style: {"width":"2.5rem"},
  class: "d-flex flex-column"
}
const _hoisted_40 = ["title"]
const _hoisted_41 = ["onClick", "checked"]
const _hoisted_42 = {
  key: 1,
  style: {"width":"2.5rem"},
  class: "d-flex flex-column"
}
const _hoisted_43 = ["title"]
const _hoisted_44 = ["onClick", "checked"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_DeviceLabel = _resolveComponent("DeviceLabel")!
  const _component_UserNameLabel = _resolveComponent("UserNameLabel")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_DeviceMessageLogsModal = _resolveComponent("DeviceMessageLogsModal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "pageLoader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.id'),
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestDTO.id) = $event))
                        }, null, 8, _hoisted_10), [
                          [_vModelText, _ctx.requestDTO.id]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control form-control-sm",
                          placeholder: _ctx.helper.trans('labels.name'),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestDTO.query) = $event))
                        }, null, 8, _hoisted_14), [
                          [_vModelText, _ctx.requestDTO.query]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Multiselect, {
                          id: "statuses",
                          class: "multiselect-sm",
                          modelValue: _ctx.requestDTO.statuses,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requestDTO.statuses) = $event)),
                          options: ['online', 'offline'],
                          "custom-label": (opt) => _ctx.helper.trans(`device_status.${opt}`),
                          multiple: true,
                          "select-label": "Select",
                          placeholder: _ctx.helper.trans('labels.status')
                        }, null, 8, ["modelValue", "custom-label", "placeholder"])
                      ])
                    ])
                  ]),
                  (_ctx.isOperator || _ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_TraderMultiselect, {
                              multiple: true,
                              modelValue: _ctx.tradersFilter,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tradersFilter) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isOperator || _ctx.isAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.isDeleted) = $event)),
                              "true-value": "true",
                              type: "checkbox",
                              value: "",
                              id: "isDeleted"
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.requestDTO.isDeleted]
                            ]),
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.helper.trans('labels.deleted')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => _ctx.clearFilters(), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("div", { class: "form-group col-sm-12" })
                ], -1)),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("table", _hoisted_30, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.helper.trans('labels.id')), 1),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.name')), 1),
                        (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_33, _toDisplayString(_ctx.helper.trans('labels.trader')), 1))
                          : _createCommentVNode("", true),
                        _cache[9] || (_cache[9] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (device) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: device.id,
                          class: ""
                        }, [
                          _createElementVNode("td", null, [
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              title: device.id
                            }, [
                              _createTextVNode(_toDisplayString(device.id.substr(0, 8)), 1)
                            ], 8, _hoisted_34)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ]),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createVNode(_component_copy_button, {
                              value: device.id
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_DeviceLabel, {
                              "onDevice:updated": _ctx.onDeviceUpdated,
                              device: device
                            }, null, 8, ["onDevice:updated", "device"])
                          ]),
                          (_ctx.isAdmin || _ctx.isOperator || _ctx.isTeamLead)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                                (device.trader)
                                  ? (_openBlock(), _createBlock(_component_UserNameLabel, {
                                      key: 0,
                                      "onTrader:updated": _ctx.onTraderUpdated,
                                      "show-controls": _ctx.isOperator || _ctx.isAdmin,
                                      user: device.trader
                                    }, null, 8, ["onTrader:updated", "show-controls", "user"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  ((_ctx.isAdmin || _ctx.isOperator) && _ctx.store.getters.getAppData?.IGNORE_OFFLINE_NOTIFICATION_ENABLED)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _withDirectives((_openBlock(), _createElementBlock("small", {
                                          class: "form-switch",
                                          title: `${_ctx.helper.trans(device.ignoreOfflineNotifications ? 'device_status.ignore_offline_enabled' : 'device_status.ignore_offline_disabled')}`
                                        }, [
                                          _createElementVNode("input", {
                                            id: "ignoreOfflineNotifications",
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleIgnoreOfflineStatus(device.id, device.ignoreOfflineNotifications ? 'disabled' : 'enabled')), ["prevent"]),
                                            class: "form-check-input",
                                            style: {"cursor":"pointer"},
                                            type: "checkbox",
                                            role: "switch",
                                            checked: device.ignoreOfflineNotifications
                                          }, null, 8, _hoisted_41)
                                        ], 8, _hoisted_40)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            {
                                              hover: true,
                                              left: true
                                            }
                                          ]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.isAdmin || _ctx.isOperator)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        _withDirectives((_openBlock(), _createElementBlock("small", {
                                          class: "form-switch",
                                          title: `${_ctx.helper.trans('device_status.title')}: ${_ctx.helper.trans(device.status === _ctx.DevicesStatus.OFFLINE ? 'device_status.offline' : 'device_status.online')}`
                                        }, [
                                          _createElementVNode("input", {
                                            id: "traderStatus",
                                            onClick: _withModifiers(($event: any) => (_ctx.toggleSetStatus(device.id, device.status === _ctx.DevicesStatus.OFFLINE ? _ctx.DevicesStatus.ONLINE : _ctx.DevicesStatus.OFFLINE)), ["prevent"]),
                                            class: "form-check-input",
                                            style: {"cursor":"pointer"},
                                            type: "checkbox",
                                            role: "switch",
                                            checked: device.status !== _ctx.DevicesStatus.OFFLINE
                                          }, null, 8, _hoisted_44)
                                        ], 8, _hoisted_43)), [
                                          [
                                            _directive_b_tooltip,
                                            void 0,
                                            void 0,
                                            {
                                              hover: true,
                                              left: true
                                            }
                                          ]
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: ($event: any) => (_ctx.$refs.deviceMessageLogsModal.setDevice(device)),
                                    class: "btn btn-sm btn-outline-secondary text-nowrap"
                                  }, _cache[11] || (_cache[11] = [
                                    _createElementVNode("i", { class: "fa-regular fa-comments" }, null, -1)
                                  ]), 8, _hoisted_45),
                                  (_ctx.isAdmin)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleStatusRequisites('active', device)), ["prevent"]),
                                        class: "ms-2 btn btn-sm btn-outline-success text-nowrap"
                                      }, _toDisplayString(_ctx.helper.trans('labels.enable_all_requisites')), 9, _hoisted_46))
                                    : _createCommentVNode("", true),
                                  (_ctx.isAdmin)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        type: "button",
                                        onClick: _withModifiers(($event: any) => (_ctx.toggleStatusRequisites('inactive', device)), ["prevent"]),
                                        class: "ms-2 btn btn-sm btn-outline-secondary text-nowrap"
                                      }, _toDisplayString(_ctx.helper.trans('labels.disable_all_requisites')), 9, _hoisted_47))
                                    : _createCommentVNode("", true),
                                  (_ctx.isAdmin)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 4,
                                        type: "button",
                                        onClick: _withModifiers(($event: any) => (_ctx.deleteRequisites(device)), ["prevent"]),
                                        class: "ms-2 btn btn-sm btn-outline-danger text-nowrap"
                                      }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fa fa-trash" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.delete_requisites')), 1)
                                      ], 8, _hoisted_48))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[8] || (_cache[8] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_DeviceMessageLogsModal, { ref: "deviceMessageLogsModal" }, null, 512)
      ]),
      _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512)
    ]),
    _: 1
  }, 512))
}